export const animationDurationFast = 115;
export const animationDurationNormal = 150;
export const animationDurationSlow = 250;

export const typeColorMap = {
  string: 'var(--type-string)',
  array: 'var(--type-array)',
  object: 'var(--type-object)',
  number: 'var(--type-number)',
  null: 'var(--type-null)',
  boolean: 'var(--type-boolean)'
};
